<template>
    <div>
        <SingleDocument/>
    </div>
</template>
<script>
    import SingleDocument from '@/components/documents/SingleDocument';

    export default {
        name: 'document',
        components: {
            SingleDocument,
        }
    }
</script>